import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withCtx as _withCtx, createTextVNode as _createTextVNode, vModelText as _vModelText, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-00504b69"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tab-pane fade active show" }
const _hoisted_2 = { class: "card card-flush mb-6 mb-xl-9" }
const _hoisted_3 = { class: "card-header mt-6" }
const _hoisted_4 = { class: "row w-100" }
const _hoisted_5 = { class: "row d-flex flex-fill" }
const _hoisted_6 = { class: "col-12 col-sm-4" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Worker type", -1))
const _hoisted_8 = { class: "col-12 col-sm-4 mt-3 mt-sm-0" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Branch", -1))
const _hoisted_10 = {
  key: 0,
  class: "col-12 col-sm-4 mt-3 mt-sm-0"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Currency", -1))
const _hoisted_12 = {
  key: 0,
  class: "d-flex align-items-end"
}
const _hoisted_13 = { class: "d-flex flex-column flex-sm-row justify-content-start align-items-start align-items-sm-center mt-2 fixed-height mb-5 mb-sm-0" }
const _hoisted_14 = { class: "mt-5 me-5 mb-4 mb-sm-0" }
const _hoisted_15 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "flexSwitchDefault"
}, "Enable night rates", -1))
const _hoisted_17 = {
  key: 0,
  class: "d-flex align-content-between flex-column"
}
const _hoisted_18 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Night hours ")
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-info-circle ms-1" }, null, -1))
const _hoisted_21 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Minimum call", -1))
const _hoisted_24 = { class: "card-body p-9 pt-4 mt-6 mt-md-5 mt-lg-4 mt-xl-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SkillsDropdown = _resolveComponent("SkillsDropdown")!
  const _component_BranchesDropdown = _resolveComponent("BranchesDropdown")!
  const _component_CurrenciesDropdown = _resolveComponent("CurrenciesDropdown")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!
  const _component_SkillsTable = _resolveComponent("SkillsTable")!
  const _component_el_empty = _resolveComponent("el-empty")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", null, [
                _hoisted_7,
                _createVNode(_component_SkillsDropdown, {
                  modelValue: _ctx.query.skill_id,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.query.skill_id) = $event)),
                  onClear: _cache[1] || (_cache[1] = ($event: any) => (_ctx.query.branch_id == '')),
                  onHasFrequentSkills: _cache[2] || (_cache[2] = freq => (_ctx.query.skill_id = freq)),
                  companyID: _ctx.client.id
                }, null, 8, ["modelValue", "companyID"])
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", null, [
                _hoisted_9,
                _createVNode(_component_BranchesDropdown, {
                  modelValue: _ctx.query.branch_id,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.query.branch_id) = $event)),
                  disabled: _ctx.query.skill_id == ''
                }, null, 8, ["modelValue", "disabled"])
              ])
            ]),
            (_ctx.query.skill_id != '')
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("div", null, [
                    _hoisted_11,
                    _createVNode(_component_CurrenciesDropdown, {
                      modelValue: _ctx.currency_id,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.currency_id) = $event))
                    }, null, 8, ["modelValue"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        (_ctx.query.skill_id != '')
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.hasEnabledNightHours) = $event)),
                      id: "flexSwitchDefault"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.hasEnabledNightHours]
                    ]),
                    _hoisted_16
                  ])
                ]),
                (_ctx.hasEnabledNightHours)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _createElementVNode("label", _hoisted_18, [
                        _hoisted_19,
                        _createVNode(_component_el_tooltip, {
                          class: "item",
                          effect: "dark",
                          content: "Define when the 'NIGHT BONUS' starts and finishes (e.g. 19:00 - 07:00)",
                          placement: "top-start"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_20
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        _withDirectives(_createElementVNode("input", {
                          id: "night_hours_1",
                          class: "form-control me-4 w-100px h-40px",
                          inputmode: "text",
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.nightHours.night_start) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.nightHours.night_start]
                        ]),
                        _withDirectives(_createElementVNode("input", {
                          id: "night_hours_2",
                          class: "form-control me-2 w-100px h-40px",
                          inputmode: "text",
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.nightHours.night_end) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.nightHours.night_end]
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.query.skill_id != 'frequent')
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _hoisted_23,
                    _withDirectives(_createElementVNode("input", {
                      class: "form-control me-2 h-40px m-b-1px w-50",
                      inputmode: "text",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.minimum_call) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.minimum_call]
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_24, [
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_LoadingSpinner, { key: 0 }))
          : (!_ctx.loading && _ctx.query.skill_id != '')
            ? (_openBlock(), _createBlock(_component_SkillsTable, {
                key: 1,
                skillID: _ctx.query.skill_id,
                onSaveEvent: _ctx.handleSave,
                onUpdateEvent: _ctx.handleUpdate,
                hasNightHours: _ctx.hasEnabledNightHours
              }, null, 8, ["skillID", "onSaveEvent", "onUpdateEvent", "hasNightHours"]))
            : (_openBlock(), _createBlock(_component_el_empty, {
                key: 2,
                description: "Please select worker type to continue."
              }))
      ])
    ])
  ]))
}